import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Nav from "../main/nav";
import Footer from "../main/footer";
import ExportHeader from "../main/ExportHeader";
import ExportRatioChart from "./ExportRetioChart";
import axios from "axios";
import Swal from "sweetalert2";
import "./css.css";
import { useLegendMapArea } from "../main/LegendMap";
import ChartGridView from "../main/ChartGridView";
import { ApiBaseUrl } from "../../Config";

export default function ExportIndex() {
  const [ExportChart, setExportChart] = useState([]);
  const [MezzanineChart, setMezzanineChart] = useState([]);
  const [OYCChart, setOYCChart] = useState([]);
  const [OYCChartTable, setOYCChartTable] = useState([]);
  const [loading, setLoading] = useState(false);

  const [warehouseName, setWarehouseName] = useState("");
  const [type, setType] = useState("");
  const [ids, setIds] = useState([]);
  const Colors = ["#FFBB28", "#00C49F", "#0088FE", "#A28EFF", "#FF8042",'#93DCFF'];
  const fetchData = async (warehouse_name) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${ApiBaseUrl}/warehouse/map/dashboard?warehouse_name=${warehouse_name}`
      );

      const Data = response.data?.data ?? {};

      let chartData = [
        {
          label: "hold_cargo",
          name: "Hold-Cargo",
          value: Data?.hold_cargo_sqm,
          grid: Data?.hold_cargo,
          ids: Data?.hold_cargo_ids,
        },
        {
          label: "unassigned",
          name: "Unassigned with Cargo",
          value: Data?.unassigned_sqm,
          grid: Data?.unassigned,
          ids: Data?.unassigned_ids,
        },
        {
          label: "assigned",
          name: "Assigned with Cargo",
          value: Data?.assigned_sqm,
          grid: Data?.assigned,
          ids: Data?.assigned_ids,
        },
        {
          label: "partially",
          name: "Partially Occupied with assigned / unassigned Cargo",
          value: Data?.partially_sqm,
          grid: Data?.partially,
          ids: Data?.partially_ids,
        },
        {
          label: "available",
          name: "Available",
          value: Data?.available_sqm,
          grid: Data?.available,
          ids: Data?.available_ids,
        },
        {
          label: "total",
          name: "Total",
          value: Data?.available_sqm+Data?.hold_cargo_sqm+Data?.unassigned_sqm+Data?.assigned_sqm+Data?.partially_sqm,
          grid: Data?.available+Data?.hold_cargo+Data?.unassigned+Data?.assigned+Data?.partially,
          ids: Data?.available_ids+Data?.hold_cargo_ids+Data?.unassigned_ids+Data?.assigned_ids+Data?.partially_ids,
        },
      ];
      if (warehouse_name === "Export") {
        setExportChart(chartData);
      } else if (warehouse_name === "Mazzanine") {
        setMezzanineChart(chartData);
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        text: `Error fetching data: ${error.message}`,
        timer: 3000,
        showConfirmButton: false,
      });
    } finally {
      setLoading(false);
    }
  };
  const getOYCData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `https://ctas.live/backend/api/export/map/data?name=OYC`,
        { headers: { "Content-Type": "application/json" } }
      );

      const OYC = response.data?.data ?? [];

      let totalOccupiedSum = 0;
      let table = [];

      OYC.forEach((oyc_grid) => {
        if (!oyc_grid?.camera_locations) return;

        let gridAllocation = [];
        table.push({
          label: oyc_grid?.new_location_code,
          value: oyc_grid?.carting_data?.length ?? 0,
        });
        if (
          oyc_grid?.carting_data?.length > 0 ||
          oyc_grid?.destuffing_data?.length > 0
        ) {
          try {
            const parsed = JSON.parse(oyc_grid?.grid_allocation) ?? {};
            for (const value of Object.values(parsed)) {
              let values = [];
              try {
                values = Array.isArray(value) ? value : JSON.parse(value);
              } catch {
                continue;
              }
              if (Array.isArray(values)) {
                gridAllocation.push(...values);
              }
            }
          } catch {}
        }

        totalOccupiedSum += gridAllocation.length;
      });
      setOYCChartTable(table);
      setOYCChart([
        {
          name: "Assigned with Cargo",
          value: Math.max(1, totalOccupiedSum ?? 0),
        },
      ]);
    } catch (error) {
      Swal.fire({
        icon: "error",
        text: `Error fetching data: ${error.message}`,
        timer: 3000,
        showConfirmButton: false,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData("Mazzanine");
    fetchData("Export");
    getOYCData();
  }, []);

  const COLORS = ["#00C49F", "#0088FE", "#FFBB28", "#FF8042"];
  const data = [
    { name: "Occupied", value: 0 },
    { name: "Spill-Over", value: 0 },
    { name: "Hold-Cargo", value: 0 },
    { name: "Available", value: 2120 },
  ];

  return (
    <>
      {loading && (
        <div
          className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
          style={{ zIndex: 9999 }}
        >
          <div className="sk-chase sk-primary display-1">
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
          </div>
        </div>
      )}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <ExportHeader />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <h1 className="text-center text-primary">Welcome to Export </h1>
                <div className="row gy-6">
                  <div className="col-lg-6">
                    <div className="card box_shadow">
                      <div className="card-body">
                        <p className="m-0">Warehouse Name</p>
                        <h5 className="mt-0">EXPORT WAREHOUSE (Gate 10-13)</h5>
                        <p className="m-0">Stacking Type</p>
                        <h6 className="mt-0">GROUND STACKING</h6>
                        <div className="container text-center my-4">
                          <table className="text-center table table-borderless">
                            <thead>
                              <tr>
                                <th colSpan={6} className="fw-bold">
                                  GRID POSITION - (OCCUPIED &amp; AVAILABLE
                                  GRID)
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                {ExportChart?.map((chartData, i) => (
                                  <td
                                    style={{ backgroundColor: Colors[i] }}
                                    className="text-dark fw-bold p-1 pb-0 "
                                  >
                                    <small> {chartData?.name}</small>
                                  </td>
                                ))}
                              </tr>
                              <tr>
                                {ExportChart?.map((chartData, i) => (
                                  <td
                                    style={{ backgroundColor: Colors[i] }}
                                    className="text-dark fw-bold"
                                    data-bs-toggle="modal"
                                    data-bs-target="#exampleModal"
                                    onClick={() => {
                                      setType(chartData?.label);
                                      setIds(chartData?.ids ?? "001,002");
                                      setWarehouseName("Export");
                                    }}
                                  >
                                    {chartData?.grid}
                                  </td>
                                ))}
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <ExportRatioChart
                          data={ExportChart}
                          COLORS={Colors}
                          isShowLegend={false}
                          isCustomLegend={true}
                        />
                        <div className="links">
                          <div className="d-flex gap-3 justify-content-between">
                            <Link
                              to={"/ExportWarehouse"}
                              className="btn btn-label-primary"
                            >
                              <i className="ri ri-store-2-line ri-38px text-primary"></i>
                              Warehouse
                            </Link>
                            <Link
                              to={"/export-cargo"}
                              className="btn btn-label-primary"
                            >
                              <i className="ri ri-contract-line ri-38px text-primary"></i>
                              Active Jobs
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="card box_shadow">
                      <div className="card-body">
                        <p className="m-0">Warehouse Name</p>
                        <h5 className="mt-0">EXPORT WAREHOUSE (Gate 6-9)</h5>
                        <p className="m-0">Stacking Type</p>
                        <h6>GROUND STACKING</h6>
                        <div className="container text-center my-4">
                          <table className="text-center table table-borderless">
                            <thead>
                              <tr>
                                <th colSpan={6} className="fw-bold">
                                  GRID POSITION - (OCCUPIED &amp; AVAILABLE
                                  GRID)
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                {MezzanineChart?.map((chartData, i) => (
                                  <td
                                    style={{ backgroundColor: Colors[i] }}
                                    className="text-dark fw-bold p-1 pb-0 "
                                  >
                                    <small> {chartData?.name}</small>
                                  </td>
                                ))}
                              </tr>
                              <tr>
                                {MezzanineChart?.map((chartData, i) => (
                                  <td
                                    style={{ backgroundColor: Colors[i] }}
                                    className="text-dark fw-bold"
                                    data-bs-toggle="modal"
                                    data-bs-target="#exampleModal"
                                    onClick={() => {
                                      setType(chartData?.label);
                                      setIds(chartData?.ids);
                                      setWarehouseName("Mazzanine");
                                    }}
                                  >
                                    {chartData?.grid}
                                  </td>
                                ))}
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <ExportRatioChart
                          data={MezzanineChart}
                          COLORS={Colors}
                          isShowLegend={false}
                          isCustomLegend={true}
                        />
                        <div className="links">
                          <div className="d-flex gap-3 justify-content-between">
                            <Link
                              to={"/MezzanineGroundFloor"}
                              className="btn btn-label-primary"
                            >
                              <i className="ri ri-store-2-line ri-38px text-primary"></i>
                              Warehouse
                            </Link>
                            <Link
                              to={"/export-cargo"}
                              className="btn btn-label-primary"
                            >
                              <i className="ri ri-contract-line ri-38px text-primary"></i>
                              Active Jobs
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="card box_shadow">
                      <div className="card-body">
                        <p className="m-0">Warehouse Name</p>
                        <h5 className="mt-0">Open Yard (EWH Open Yard)</h5>
                        <p className="m-0">Stacking Type</p>
                        <h6 className="mt-0">GROUND STACKING</h6>
                        <div className="container text-center my-4">
                          <table className="text-center table table-bordered">
                            <thead>
                              <tr>
                                <th colSpan={6} className="fw-bold">
                                  GRID POSITION - (OCCUPIED & AVAILABLE GRID)
                                </th>
                              </tr>
                              <tr>
                                {[
                                  "WH Name",
                                  "Hold-Cargo",
                                  "Unassigned with Cargo",
                                  "Assigned with Cargo",
                                  "Partially Occupied with assigned / unassigned Cargo",
                                  "Available",
                                ].map((label, i) => (
                                  <td
                                    key={i}
                                    className="text-dark fw-bold px-0 pt-0 pb-1"
                                    style={{
                                      backgroundColor:
                                        i === 0 ? '#93DCFF' : Colors[i - 1],
                                    }}
                                  >
                                    <small>{label}</small>
                                  </td>
                                ))}
                              </tr>
                            </thead>
                            <tbody>
                              {OYCChartTable?.sort(
                                (a, b) =>  a.label-b.label
                              ).map((row, i) => {
                                const values = [
                                  row?.label,
                                  "0", 
                                  "0", 
                                  row?.value,
                                  "0", 
                                  "0", 
                                ];
                                return (
                                  <tr key={i}>
                                    {values.map((val, p) => (
                                      <td
                                        key={p}
                                        className="text-dark fw-bold"
                                        style={{
                                          backgroundColor:
                                            p === 0 ? '#93DCFF' : Colors[p - 1],
                                        }}
                                      >
                                        {val}
                                      </td>
                                    ))}
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>

                        <ExportRatioChart
                          data={OYCChart}
                          COLORS={["#0088FE"]}
                          isShowLegend={false}
                          isCustomLegend={true}
                        />
                        <div className="links">
                          <div className="d-flex gap-3 justify-content-center">
                            <Link
                              to={"/export-cargo"}
                              className="btn btn-label-primary"
                            >
                              <i className="ri ri-contract-line ri-38px text-primary"></i>
                              Active Jobs
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-6 BoxDisabled">
                    <div className="card box_shadow">
                      <div className="card-body">
                        <p className="m-0">Warehouse Name</p>
                        <h5 className="mt-0">
                        EXPORT WAREHOUSE – MEZZANINE FLOOR
                        (Gate 6-9)
                        </h5>
                        <p className="m-0">Stacking Type</p>
                        <h6 className="mt-0">MEZZANINE</h6>
                        <ExportRatioChart
                          data={data}
                          COLORS={Colors}
                          isShowLegend={false}
                          isCustomLegend={true}
                        />

                        <div className="links">
                          <div className="mb-2 mt-2 text-center"></div>
                          <div className="d-flex gap-3 justify-content-between">
                            <Link to={"#"} className="btn btn-label-primary">
                              <i className="ri ri-store-2-line ri-38px text-primary"></i>
                              Warehouse
                            </Link>

                            <button className="btn btn-label-primary">
                              <i className="ri ri-contract-line ri-38px text-primary"></i>
                              Active Jobs
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-6 BoxDisabled">
                    <div className="card box_shadow">
                      <div className="card-body">
                        <p className="m-0">Warehouse Name</p>
                        <h5 className="mt-0">
                        PRS (PALLETIZED RACKING SYSTEM) (Gate
                          1-5)
                        </h5>
                        <p className="m-0">Stacking Type</p>
                        <h6 className="mt-0">RACKING - LCL</h6>
                        <ExportRatioChart
                          data={data}
                          COLORS={Colors}
                          isShowLegend={false}
                          isCustomLegend={true}
                        />
                        <div className="links">
                          <div className="mb-2 mt-2 text-center"></div>
                          <div className="d-flex gap-3 justify-content-between">
                            <Link to={"#"} className="btn btn-label-primary">
                              <i className="ri ri-store-2-line ri-38px text-primary"></i>
                              Warehouse
                            </Link>
                            <button className="btn btn-label-primary">
                              <i className="ri ri-contract-line ri-38px text-primary"></i>
                              Active Jobs
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-6 BoxDisabled">
                    <div className="card box_shadow">
                      <div className="card-body">
                        <p className="m-0">Warehouse Name</p>
                        <h5 className="mt-0">
                        EXPORT WAREHOUSE (Gate 1-5)
                        </h5>
                        <p className="m-0">Stacking Type</p>
                        <h6 className="mt-0">GROUND STACKING</h6>
                        <ExportRatioChart
                          data={data}
                          COLORS={Colors}
                          isShowLegend={false}
                          isCustomLegend={true}
                        />

                        <div className="links">
                          <div className="mb-2 mt-2 text-center"></div>
                          <div className="d-flex gap-3 justify-content-between">
                            <Link to={"#"} className="btn btn-label-primary">
                              <i className="ri ri-store-2-line ri-38px text-primary"></i>
                              Warehouse
                            </Link>
                            <button className="btn btn-label-primary">
                              <i className="ri ri-contract-line ri-38px text-primary"></i>
                              Active Jobs
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-4 BoxDisabled">
                    <div className="card box_shadow">
                      <div className="card-body">
                        <p className="m-0">Warehouse Name</p>
                        <h5 className="mt-0">
                        OLD-LCL WAREHOUSE (Gate 1-4)
                        </h5>
                        <p className="m-0">Stacking Type</p>
                        <h6 className="mt-0">GROUND STACKING</h6>
                        <ExportRatioChart
                          data={data}
                          COLORS={Colors}
                          isShowLegend={false}
                          isCustomLegend={true}
                        />
                        <div className="links">
                          <div className="mb-2 mt-2 text-center"></div>
                          <div className="d-flex gap-3 justify-content-between">
                            <Link to={"#"} className="btn btn-label-primary">
                              <i className="ri ri-store-2-line ri-38px text-primary"></i>
                              Warehouse
                            </Link>
                            <button className="btn btn-label-primary">
                              <i className="ri ri-contract-line ri-38px text-primary"></i>
                              Active Jobs
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-4 BoxDisabled">
                    <div className="card box_shadow">
                      <div className="card-body">
                        <p className="m-0">Warehouse Name</p>
                        <h5 className="mt-0">
                        WORKSHOP
                        </h5>
                        <p className="m-0">Stacking Type</p>
                        <h6 className="mt-0">GROUND STACKING</h6>
                        <ExportRatioChart
                          data={data}
                          COLORS={Colors}
                          isShowLegend={false}
                          isCustomLegend={true}
                        />
                        <div className="links mt-5">
                          <div className="d-flex gap-3 justify-content-center mt-2">
                            <button className="btn btn-label-primary">
                              <i className="ri ri-contract-line ri-38px text-primary"></i>
                              Active Jobs
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-4 BoxDisabled">
                    <div className="card box_shadow">
                      <div className="card-body">
                        <p className="m-0">Warehouse Name</p>
                        <h5 className="mt-0 text-bold">
                        WORKSHOP
                        </h5>
                        <p className="m-0">Stacking Type</p>
                        <h6 className="mt-0">MEZZANINE</h6>
                        <ExportRatioChart
                          data={data}
                          COLORS={Colors}
                          isShowLegend={false}
                          isCustomLegend={true}
                        />
                        <div className="links mt-5 mb-2">
                          <div className="d-flex gap-3 justify-content-center">
                            <button className="btn btn-label-primary">
                              <i className="ri ri-contract-line ri-38px text-primary"></i>
                              Active Jobs
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* / Content */}
              <Footer />
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="exampleModal"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header py-3 bg-label-primary">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Grid Details
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              {type && ids && warehouseName && (
                <ChartGridView
                  warehouse_name={warehouseName}
                  type={type}
                  ids={ids}
                />
              )}
            </div>
            <div className="modal-footer  py-3 bg-label-primary">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
